<template>
  <div class="edit-okr">
    <div class="breadcrumb">
      <a-breadcrumb
        v-show="breadSubTitle"
        separator=">"
      >
        <a-breadcrumb-item>
          <router-link to="/">
            我的目标
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ breadSubTitle }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <div class="okr-self__info selfbox-add-style">
      <div class="okr-self__info__title">
        {{ year }}年季度回顾
      </div>
      <div class="okr-self__box">
        <div
          v-if="searchStaffInfo.userName"
          class="userInfo"
        >
          <avatar :src="searchStaffInfo.image" />
          <div>
            <div>
              <span class="okr-self__name">{{ searchStaffInfo.userName }}</span>
              <span class="okr-self__position">{{ searchStaffInfo.duty }}</span>
            </div>
            <div class="okr-self__department">
              {{ searchStaffInfo.department }}
            </div>
          </div>
        </div>
        <div
          v-if="quarterList.length>0"
          class="okr-self__info__score"
        >
          <dl
            v-for="(r,index) in quarterList"
            :key="index"
          >
            <dt>Q{{ r.quarter }}</dt>
            <dd>{{ r.evaluateOn271 || '-' }}</dd>
          </dl>
        </div>
      </div>
    </div>
    <div class="edit-okr__totalBox">
      <div class="krSEinner">
        <div>
          <strong style="margin-right:8px;">年度自评</strong>
          <a-radio-group
            button-style="solid"
            size="large"
            :value="evalData.selfEvaluateOn271"
            @change="(e) => handleScoreChange('selfEvaluateOn271',e.target.value)"
          >
            <a-radio-button value="1">
              1
            </a-radio-button>
            <a-radio-button value="6">
              6
            </a-radio-button>
            <a-radio-button value="3">
              3
            </a-radio-button>
          </a-radio-group>
          <span
            v-show="noScore"
            class="wrongTxt"
          >请选择</span>
        </div>
      </div>
      <div>
        <div>
          <strong>自评总结</strong>
          <span class="tipsTxt2">（必填）</span>
        </div>
        <div style="position:relative;">
          <a-textarea
            style="min-height: 80px; line-height: 30px; margin-top:8px; padding-bottom:10px;"
            :class="noWords? 'wrongBox': ''"
            placeholder="为自己总结下这一年的成长与收获吧~"
            maxlength="1000"
            :autosize="{ minRows: 5 }"
            :value="evalData.highlightAndWeakness"
            @blur="(e) => formateSEWords('highlightAndWeakness',e.target.value)"
            @change="(e) => handleSEWordsChange('highlightAndWeakness',e.target.value)"
            @focus="(e) => handleSEWordsClear('highlightAndWeakness')"
          />
          <span class="leftNumber">{{ evalData.highlightAndWeakness?evalData.highlightAndWeakness.length:0 }} / 1000</span>
        </div>
      </div>
    </div>
    <div class="edit-okr__footer">
      <a-button
        type="primary"
        ghost
        @click="handleClickSave"
      >
        存草稿
      </a-button>
      <a-button
        class="edit-okr__submit"
        type="primary"
        ghost
        @click="handleClickSubmit"
      >
        提交
      </a-button>
    </div>
    <a-modal
      v-model="isSucess"
      centered
      :mask-closable="false"
      :width="430"
      :footer="null"
      :closable="false"
    >
      <div class="sucessOuter">
        <img
          class="sucessIco"
          src="@assets/images/up-success.png"
        >
        <div class="sucessTxt">
          提交成功！
        </div>
        <div class="sucessTips">
          {{ CountDown }}秒
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Button, Icon, Radio, Modal, Notification, message, Breadcrumb } from 'ant-design-vue'
import Avatar from '@components/avatar/index.vue'

Vue.use(Input)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Radio)
Vue.use(Modal)
Vue.use(Breadcrumb)

export default {
  name: 'EditYearSelfEvaluation',
  components: {
    Avatar,
  },
  data() {
    return {
      evalData: {},
      originalData: {},
      quarterList: [],
      searchStaffInfo: {},
      okrId: null,
      isSucess: false,
      CountDown: '',
      breadSubTitle: '',
      haveChange: false,
      noScore: false,
      noWords: false,
      year: '',
    }
  },
  watch: {
    haveChange(r) {
      // 默认将离开页面的浏览器事件置空
      window.onbeforeunload = null
      if (r) {
        window.onbeforeunload = function(e) {
          e = window.event || e
          e.returnValue = ('您的数据尚未保存，确定离开当前页面吗？')
        }
      }
    },
  },
  created() {
    const okrId = this.$route.params.okrId
    if (okrId) {
      this.okrId = okrId
      this.fetchInfo()
      this.fetchEditDATa()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.haveChange) {
      Modal.confirm({
        title: '是否保存此次编辑内容？',
        content: '保存后下次可继续编辑。',
        icon: 'exclamation-circle',
        okText: '保存',
        cancelText: '不保存',
        onOk: () => {
          this.handleClickSave()
          next()
        },
        onCancel: () => {
          next()
          // 若不保存，将离开页面的浏览器事件置空，以免影响列表页操作
          window.onbeforeunload = null
        },
      })
    } else {
      next()
    }
  },
  beforeDestory () {
    // 页面销毁前，将事件置空
    window.onbeforeunload = null
  },
  methods: {
    // 获取信息
    async fetchInfo() {
      try {
      // 进入编辑，从接口拿自评数据
        const result = await this.$api.okr.getSEInYearDetail({ okrId: this.okrId })
        this.breadSubTitle = `${result.year}年度业绩自评表`
        this.year = result.year
        let qList = result.quarterDtoList
        if (qList.length < 4) {
          for (let n = 1; n < 5; n++) {
            if (!qList.find(q => q.quarter === n)) {
              qList.push({
                quarter: n,
                evaluateOn271: null,
              })
            }
          }
          qList = qList.sort((a, b) => {
            return a.quarter - b.quarter
          })
        }
        this.$set(this, 'quarterList', qList)
        const depLength = result.searchStaffInfo.departmentNameList.length
        this.$set(result.searchStaffInfo, 'department', result.searchStaffInfo.departmentNameList[depLength - 1])
        this.$set(this, 'searchStaffInfo', result.searchStaffInfo)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // 获取自评数据
    async fetchEditDATa() {
      const hide = message.loading('正在加载...')
      try {
        const result = await this.$api.okr.getTempSE({ id: this.okrId })
        this.originalData = {
          highlightAndWeakness: result.highlightAndWeakness,
          id: result.id,
          selfEvaluateOn271: result.selfEvaluateOn271,
        }
        this.$set(this, 'evalData', {
          highlightAndWeakness: result.highlightAndWeakness,
          id: result.id,
          selfEvaluateOn271: result.selfEvaluateOn271,
        })
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      } finally {
        hide()
      }
    },
    /**
     * selfEvaluateOn271 字段改变，加入数组，展开收起亮点不足
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleScoreChange(k, v) {
      this.$set(this.evalData, k, v)
      this.$set(this, 'noScore', false)
      this.compareData()
    },
    /**
     * highlightAndWeakness 格式化文本，多个空格合并成一个，并加入数组
     * @param {String} k 字段名
     * @param {any} v 值
     */
    formateSEWords(k, v) {
      v = v.replace(/[ ]+/g, ' ')
      this.$set(this.evalData, k, v)
      this.compareData()
    },
    /**
     * highlightAndWeakness 字段改变，加入数组
     * @param {String} k 字段名
     * @param {any} v 值
     */
    handleSEWordsChange(k, v) {
      this.$set(this.evalData, k, v)
      this.$set(this, 'noWords', false)
      this.compareData()
    },
    /**
     * highlightAndWeakness 字段清空（校验报错时，增加报错文本，获取焦点清空该文本），加入数组
     * @param {String} k 字段名
     */
    handleSEWordsClear(k) {
      if (this.noWords) {
        this.$set(this.evalData, k, '')
        this.$set(this, 'noWords', false)
        this.compareData()
      }
    },
    /**
     * 点击保存按钮
     */
    async handleClickSave() {
      try {
        await this.$api.okr.preserveSE(this.evalData)
        Notification.open({
          type: 'success',
          message: '已保存',
          description:
            '已为您保存成功啦~',
          style: 'background-color:#E4FDDA',
        })
        this.originalData = this.evalData
        this.haveChange = false
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    /**
     * 点击提交按钮
     */
    handleClickSubmit() {
      // 判断是否有为空的情况，报错提醒
      let haveBlank = false
      const { evalData } = this
      if (!evalData.selfEvaluateOn271) {
        this.noScore = true
        haveBlank = true
      }
      if (evalData.noWords) {
        haveBlank = true
      }
      if (!evalData.highlightAndWeakness || evalData.highlightAndWeakness === '请输入自评总结') {
        this.noWords = true
        evalData.highlightAndWeakness = '请输入自评总结'
        haveBlank = true
      }
      if (haveBlank) {
        Notification.open({
          type: 'error',
          message: '未完成表单填写',
          description:
            '未完成表单填写，请注意红色提示文字。',
          style: 'background-color:#FFECE4',
        })
      } else {
        Modal.confirm({
          title: '是否确认提交自评表单？',
          content: '提交表单后，将无法再次编辑',
          icon: 'exclamation-circle',
          okText: '提交',
          cancelText: '不提交',
          onOk: () => {
            // 上传数据
            this.submitData()
          },
        })
      }
    },
    /**
     * 提交自评表单数据
     */
    async submitData() {
      // eslint-disable-next-line
      console.log('evalData',this.evalData)
      try {
        await this.$api.okr.submitSEInYear(this.evalData)
        this.haveChange = false

        // 提交成功 3秒倒计时
        this.isSucess = true
        const TIME_COUNT = 3
        this.CountDown = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.CountDown > 1 && this.CountDown <= TIME_COUNT) {
            this.CountDown--
          } else {
            clearInterval(this.timer)
            this.timer = null
            // 跳转的页面写在此处
            this.$router.replace({
              name: 'YearSelfEvaluationDetail',
              params: {
                okrId: this.okrId,
              },
            })
          }
        }, 1000)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    /**
     * 收集表单数组，跟进入页面加载时数据进行对比，若不同，返回true
     */
    compareData() {
      this.haveChange = false
      const { originalData, evalData } = this
      if ((originalData.selfEvaluateOn271 !== evalData.selfEvaluateOn271) || (originalData.highlightAndWeakness !== evalData.highlightAndWeakness)) {
        this.haveChange = true
      }
      // eslint-disable-next-line
      console.log('0','originalData',this.originalData,'evalData',evalData, this.haveChange)
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

.edit-okr {position: relative;  padding-bottom: 66px;
  &__totalBox {
    background: @white;
    border-radius: 4px;
    padding: 16px;
  }
  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    padding: 0 170px;
    background: @white;
    z-index: 2;
    > button {
      padding: 0 30px;
      margin-left: 12px;
    }
  }
  &__submit {
    background: #005EFE;

    &:hover,
    &:active,
    &:focus {
      background: @blue;
    }
  }
  .krSEinner{padding-bottom: 16px;}
  .tipsTxt2{font-size: 14px;color:#FF3000;}
}
.breadcrumb{
margin-bottom: 40px;
padding-bottom:16px;
border-bottom: 1px solid #DDD;
}
.okr-time{
position:absolute;
right: 0;
top:38px;
height: 40px;
line-height: 40px;
font-size:13px;
color:#ccc;
}
.wrongTxt{font-size:14px; color:#FF3000; padding: 0 4px;}

.scoreTxt{font-size:24px;color:@blue; display: inline-block; width:48px; text-align: center;
 span{position: relative; top:-2px;}}
.wrongBox{border-color:#FF3000; color:#FF3000;}
.okrScoreBox{display: flex; align-items: center;}
.sucessOuter{text-align: center;}
.sucessIco{width:66px; margin-top: 16px; margin-bottom: 18px;}
.sucessTxt{font-size:14px; margin-bottom: 30px;}
.sucessTips{font-size: 12px; color:#9B9B9B;padding-bottom: 16px;}
.ant-radio-group-large .ant-radio-button-wrapper{width:64px; text-align: center;}
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {background: @blue; border-color:@blue;}
.leftNumber{position: absolute; bottom:2px; right:10px; color:#999;}
.okr-self {
  &__info {
    padding: 20px 32px;
    background-color: @white;
    img {
      margin-right: 8px;
      width: 40px;
      height: 40px;
      border-radius: 40px;
    }
    &__title{font-size: 16px; font-weight: bold; margin-bottom:8px;}
    &__score{display: flex; flex-direction: row; align-items: center; justify-content: center; height:80px; border-radius: 4px;
    dl{margin-bottom: 0; text-align: center;}
    dt{font-size: 12px; color:#999;}
    dt+dd{margin-top: 4px; margin-bottom: 0;}
    dl+dl{margin-left:36px;}}
  }
  &__box{display:flex; flex-direction: row; align-items: center;}
  &__name,
  &__position {
    font-size: @large;
  }
  &__name {
    font-weight: 600;
  }
  &__department {
    color: #999;
    font-size: @small;
  }
}
.selfbox-add-style{border-radius: 4px; margin-bottom: 16px;}
.userInfo{display: flex; align-items: center; padding-right: 48px; border-right:#eee 1px solid; margin-right: 42px;}
</style>
